module.exports = __webpack_public_path__ + "static/media/firmingcream.8e9ceae6.png";